import { ValueType } from '../types';

export const isCustomValueType = (valueType?: ValueType): valueType is ValueType.Custom =>
  valueType === ValueType.Custom;
